import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  TextField,
  Autocomplete,
  Box,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

import { companyWiseEmp } from "../../actions/Companywiseclient";

const UserEnableDisableConfiguration = ({ companyId, siteId }) => {
  const [userList, setUserList] = React.useState([]);
  const [isActive, setIsActive] = React.useState("true");
  const [selectedUsers, setSelectedUsers] = React.useState([]);
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const getSetUserList = async () => {
    const response = await companyWiseEmp.getAllActiveInActiveUsers({
      companyId: companyId,
      isActive: isActive,
      siteId: siteId?.id || null,
    });
    if (response && response.responseCode === 200) {
      setUserList(response.data);
    } else {
      setUserList([]);
    }
  };

  const handleSetActiveInActiveUsers = async () => {
    const response = await companyWiseEmp.setActiveInActiveUsers({
      userIds: selectedUsers.map((user) => user.id),
      isActive: isActive === "true" ? "false" : "true",
    });
    if (response && response.responseCode === 200) {
      setIsActive("true");
      setSelectedUsers([]);
      getSetUserList();
      return alert(response.responseDescription);
    } else {
      return alert("Something Went Wrong.");
    }
  };

  React.useEffect(() => {
    if (companyId) {
      getSetUserList();
    } else {
      setUserList([]);
    }
    setSelectedUsers([]);
  }, [companyId, isActive, siteId]);
  return (
    <Accordion className="main_accoardian" defaultExpanded={true}>
      <AccordionSummary
        className="accordianHeader"
        expandIcon={
          <AddCircleIcon fontSize="large" style={{ color: "white" }} />
        }
        aria-controls="panel1a-content"
        style={{
          background: "rgb(10 166 141)",
          borderRadius: "10px 10px 0px 0px",
          overflow: "hidden",
        }}
      >
        <Grid>
          <h3
            style={{
              color: "#fff",
              marginLeft: "10px",
              padding: "10px 2px",
            }}
          >
            User Enable Disable Configuration:-
          </h3>
        </Grid>
      </AccordionSummary>

      <AccordionDetails className="accoardian_body">
        <Box sx={{ my: 1, mx: 1 }}>
          <FormControl
            sx={{
              width: "60%",
              marginLeft: "auto",
            }}
          >
            <RadioGroup
              row
              value={isActive}
              onChange={(e) => setIsActive(e.target.value)}
            >
              <FormControlLabel
                value={"true"}
                control={<Radio />}
                label={"Active"}
              />
              <FormControlLabel
                value={"false"}
                control={<Radio />}
                label={"In Active"}
              />
            </RadioGroup>
          </FormControl>
          <Grid container spacing={2}>
            <Grid item>
              <div className="field_box">
                <Autocomplete
                  multiple
                  size="small"
                  className="select_box_forCompanyWise"
                  limitTags={1}
                  id="multiple-limit-tags"
                  value={selectedUsers}
                  options={
                    Boolean(userList.length)
                      ? [{ name: "Select All" }, ...userList]
                      : userList
                  }
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    // const filteredCompanyUsers = companyUsers?.filter(
                    //   (user) => !user?.isApproverSet
                    // );
                    const isSelectAll = option?.name === "Select All";
                    const isAllSelected =
                      Boolean(userList?.length > 0) &&
                      Boolean(selectedUsers?.length === userList?.length);
                    if (Boolean(option?.name === "Select All")) {
                      return (
                        <li key={key} {...optionProps}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={isSelectAll ? isAllSelected : selected}
                          />
                          {Boolean(option?.name === "Select All")
                            ? `${option?.name}`
                            : `${option?.name}(${option?.empCode})`}
                        </li>
                      );
                    }
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {Boolean(option?.empCode === "Select All")
                          ? `${option?.name}`
                          : `${option?.name}(${option?.empCode})`}
                      </li>
                    );
                  }}
                  getOptionLabel={(option) =>
                    option.name === "Select All"
                      ? option.name
                      : `${option.name}(${option.empCode})`
                  }
                  disablePortal={true}
                  fullWidth
                  onChange={(event, newValue) => {
                    if (
                      Boolean(newValue.length) &&
                      newValue[newValue.length - 1].name === "Select All"
                    ) {
                      if (
                        Boolean(userList?.length) &&
                        Boolean(userList?.length === newValue?.length - 1)
                      ) {
                        setSelectedUsers([]);
                      } else {
                        setSelectedUsers(userList);
                      }
                    } else {
                      setSelectedUsers(newValue);
                    }
                  }}
                  disableCloseOnSelect
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      margin="dense"
                      placeholder="Select User"
                    />
                  )}
                />
              </div>
            </Grid>
            <Grid item>
              {Boolean(selectedUsers.length) && (
                <div
                  className="field_box"
                  style={{
                    // backgroundColor: "orange",
                    paddingBottom: "12px",
                  }}
                >
                  <div
                    className="field_box_btn1"
                    style={{
                      cursor: "pointer",
                      paddingLeft: "25px",
                      paddingRight: "25px",
                      paddingTop: "8px",
                      paddingBottom: "8px",
                      marginTop: 12,
                    }}
                    onClick={handleSetActiveInActiveUsers}
                  >
                    {isActive === "true" ? "Set as In Active" : "Set as Active"}
                  </div>
                </div>
              )}
            </Grid>
          </Grid>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default UserEnableDisableConfiguration;
